import React from 'react';
import { education } from './ResumeData';

export function Education() {
  return (
    <main className="Education">
      <h2>Education</h2>
      <article className="card text-start">
        <div className="card-body">
          <h3 className="card-title h5">{education.degree}</h3>
          <p className="mb-1"><strong>{education.institution}</strong></p>
          <p className="mb-0">{education.years}</p>
        </div>
      </article>
    </main>
  );
}
